import CountryStateCity from '../../../components/CountryStateCity';
import {
  Alert,
  Form,
  Card,
  Typography,
  Row,
  Col,
  Input,
  Avatar,
  Radio,
} from 'antd';

import { getAll as getIDTypes } from '../../../api/module/identification_types';
import { CustomSelector } from '../../../components';
import { IsRole, validatorNumbers } from '../../../utils/helpers/helpers';
import { useState } from 'react';
import { BankOutlined, UserOutlined } from '@ant-design/icons';
import SelectOrganizationType from '../../../components/SelectOrganizationType';

const { Title } = Typography;

const LegalPersonFormGeneralSection = ({
  readOnly = false,
  initialValues = {},
  divRef,
}) => {
  const [superUser] = useState(IsRole(6));

  function calcularDigitoVerificacion(e, setFieldsValue = () => {}) {
    let myNit = e.target.value;
    let vpri, x, y, z;
    // Se limpia el Nit
    myNit = myNit.replace(/\s/g, ''); // Espacios
    myNit = myNit.replace(/,/g, ''); // Comas
    myNit = myNit.replace(/\./g, ''); // Puntos
    myNit = myNit.replace(/-/g, ''); // Guiones
    // Se valida el nit
    if (isNaN(myNit)) {
      console.log("El nit/cédula '" + myNit + "' no es válido(a).");
      return '';
    }
    // Procedimiento
    vpri = new Array(16);
    z = myNit.length;

    vpri[1] = 3;
    vpri[2] = 7;
    vpri[3] = 13;
    vpri[4] = 17;
    vpri[5] = 19;
    vpri[6] = 23;
    vpri[7] = 29;
    vpri[8] = 37;
    vpri[9] = 41;
    vpri[10] = 43;
    vpri[11] = 47;
    vpri[12] = 53;
    vpri[13] = 59;
    vpri[14] = 67;
    vpri[15] = 71;

    x = 0;
    y = 0;
    for (var i = 0; i < z; i++) {
      y = myNit.substr(i, 1);
      x += y * vpri[z - i];
    }

    y = x % 11;
    const res = y > 1 ? 11 - y : y;
    if (res) {
      setFieldsValue({ digito_verificacion: res });
    } else {
      alert('Verifique el número de documento registrado');
      setFieldsValue({ digito_verificacion: '' });
      setFieldsValue({ numero_identificacion: '' });
    }
  }

  return (
    <>
      <Card
        size={'small'}
        bordered={false}
        title={
          <Title level={3}>
            <Avatar
              size={32}
              icon={<BankOutlined />}
              style={{ backgroundColor: '#20b2aa', color: 'white' }}
              shape="square"
            />{' '}
            Identificación general
          </Title>
        }
      >
        <Row gutter={12} ref={divRef}>
          <Col span={12}>
            <Form.Item
              name="primer_nombre_razon_social"
              label="Nombre Razón social"
              rules={[
                {
                  required: true,
                  message: 'Razón social es requerido',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Nombre Razón social..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="sigla_comercial"
              label="Sigla o nombre comercial"
              tooltip="El nombre comercial se debe agregar solo si es diferente al nombre de la razón social"
            >
              <Input
                allowClear
                placeholder="Sigla o nombre comercial..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="constituido_colombia"
              label="¿Está constituido en Colombia?"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group disabled={readOnly}>
                <Radio value={true}>Si</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Form.Item noStyle dependencies={['constituido_colombia']}>
            {({ getFieldValue }) =>
              !getFieldValue('constituido_colombia') ? (
                <Col span={12}>
                  <Form.Item
                    name="tipo_identificacion"
                    label="Tipo de documento"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    valuePropName="initialValue"
                  >
                    <CustomSelector
                      endpointFetch={getIDTypes}
                      valueName="id"
                      labelName="nombre"
                      disabled={readOnly || !superUser}
                    />
                  </Form.Item>
                </Col>
              ) : null
            }
          </Form.Item>
        </Row>
        {!superUser && (
          <Row gutter={12}>
            <Col span={24}>
              <Alert
                style={{ marginBottom: '15px' }}
                message="Atención"
                description={
                  'Si la información de su NIT o documento equivalente se encuentra errada, por favor comuníquese con la entidad'
                }
                type={'info'}
                showIcon
              />
            </Col>
          </Row>
        )}
        <Row gutter={12}>
          <Form.Item noStyle dependencies={['constituido_colombia']}>
            {({ getFieldValue, setFieldValue }) =>
              getFieldValue('constituido_colombia') === true ? (
                <Col span={10}>
                  <Form.Item
                    label="NIT o documento equivalente"
                    name="numero_identificacion"
                    rules={[
                      {
                        required: true,
                      },
                      validatorNumbers(9),
                    ]}
                  >
                    <Input
                      onBlur={(e) =>
                        calcularDigitoVerificacion(e, setFieldValue)
                      }
                      allowClear
                      placeholder="NIT o documento equivalente"
                      disabled={readOnly || !superUser}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col span={12}>
                  <Form.Item
                    label="Documento equivalente al NIT"
                    name="numero_identificacion"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      allowClear
                      placeholder="NIT o documento equivalente"
                      disabled={readOnly || !superUser}
                    />
                  </Form.Item>
                </Col>
              )
            }
          </Form.Item>
          <Form.Item
            noStyle
            dependencies={['constituido_colombia', 'numero_identificacion']}
          >
            {({ getFieldValue }) =>
              getFieldValue('constituido_colombia') === true ? (
                <Col span={2}>
                  <Form.Item
                    name="digito_verificacion"
                    label="DV"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="DV" disabled />
                  </Form.Item>
                </Col>
              ) : null
            }
          </Form.Item>
          <Col span={12}>
            <Form.Item
              noStyle
              dependencies={['constituido_colombia', 'numero_identificacion']}
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name="nitConfirm"
                  label="Confirme el NIT o documento"
                  rules={[
                    {
                      required: true,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          !value ||
                          getFieldValue('numero_identificacion') === value
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('El NIT no coincide!'));
                      },
                    }),
                    getFieldValue('constituido_colombia')
                      ? validatorNumbers(9)
                      : {},
                  ]}
                >
                  <Input
                    type="text"
                    onPaste={(e) => e.preventDefault()}
                    allowClear
                    placeholder="Confirma el Nit o documento equivalente"
                    disabled={readOnly || !superUser}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="tipo_organizacion"
              label="Tipo de organización"
              rules={[
                {
                  required: true,
                  message: 'Tipo de organización es requerido',
                },
              ]}
              valuePropName="organization_type"
            >
              <SelectOrganizationType disabled={readOnly} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="representante_nombre"
              label="Nombre Representante legal"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Nombre Representante legal"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="representante_apellido"
              label="Apellido Representante legal"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Apellido Representante legal"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="representante_tipo_identificacion"
              label="Tipo de documento del Representante Legal"
              rules={[
                {
                  required: true,
                },
              ]}
              valuePropName="initialValue"
            >
              <CustomSelector
                endpointFetch={getIDTypes}
                valueName="id"
                labelName="nombre"
                disabled={readOnly || !superUser}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              noStyle
              dependencies={['representante_tipo_identificacion']}
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name="representante_numero_identificacion"
                  label="Número de documento del Representante Legal"
                  rules={[
                    {
                      required: true,
                    },
                    [7, 15].includes(
                      getFieldValue('representante_tipo_identificacion'),
                    )
                      ? validatorNumbers(6)
                      : {},
                  ]}
                >
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Número de documento del Representante Legal"
                    disabled={readOnly}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={8}>
            <Form.Item
              name="numero_celular"
              label="Teléfono de notificación"
              rules={[
                {
                  required: true,
                },
                validatorNumbers(7, true),
              ]}
            >
              <Input
                placeholder="Teléfono de notificación"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="celularConfirm"
              label="Confirme el teléfono de notificación"
              rules={[
                {
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('numero_celular') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('El Teléfono de notificación no coincide!'),
                    );
                  },
                }),
                validatorNumbers(7, true),
              ]}
            >
              <Input
                onPaste={(e) => e.preventDefault()}
                placeholder="Teléfono de notificación"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="otros_numeros_telefonicos"
              label="Otros números telefónicos"
            >
              <Input
                allowClear
                placeholder="Otros números telefónicos"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={18}>
            <Form.Item
              name="notificacion_direccion"
              label="Dirección de notificación"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Dirección de notificación"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="codigo_postal"
              label="Código postal"
              rules={[
                {
                  validator(_, value) {
                    if (value != null && value.length > 0) {
                      if (value.length >= 3 && value.length <= 8) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Código postal no válido!');
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Código postal"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
        </Row>
        <CountryStateCity
          countryKey="notificacion_pais"
          stateKey="notificacion_estado"
          cityKey="notificacion_ciudad"
          countryLabel="País de notificación"
          stateLabel="Departamento de notificación"
          cityLabel="Ciudad de notificación"
          country={initialValues.notificacion_pais}
          state={initialValues.notificacion_estado}
          city={initialValues.notificacion_ciudad}
          required={true}
          disabled={readOnly}
        />
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="notificacion_email"
              label="Correo electrónico de notificación"
              rules={[
                {
                  required: true,
                  type: 'email',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Correo electrónico de notificación"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="correoConfirm"
              label="Confirme el Correo electrónico de notificación"
              rules={[
                {
                  required: true,
                  type: 'email',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      !value ||
                      getFieldValue('notificacion_email') === value
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        'El correo electrónico de notificación no coincide!',
                      ),
                    );
                  },
                }),
              ]}
            >
              <Input
                allowClear
                onPaste={(e) => e.preventDefault()}
                placeholder="Confirme el correo electrónico de notificación"
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        size={'small'}
        bordered={false}
        title={
          <Title level={3}>
            <Avatar
              size={32}
              icon={<UserOutlined />}
              style={{ backgroundColor: '#20b2aa', color: 'white' }}
              shape="square"
            />{' '}
            Persona de contacto
          </Title>
        }
      >
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              name="nombres_persona_contacto"
              label="Nombre(s)"
              rules={[
                {
                  required: true,
                  message: 'Nombre(s) es requerido',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Nombre(s)..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="apellidos_persona_contacto"
              label="Apellido(s)"
              rules={[
                {
                  required: true,
                  message: 'Apellido(s) es requerido',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Apellido(s)..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="telefonos_persona_contacto"
              label="Teléfono(s)"
              rules={[
                {
                  required: true,
                  message: 'Teléfono(s) es requerido',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Teléfono(s)..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="email_persona_contacto"
              label="Correo electrónico"
              rules={[
                {
                  required: true,
                  message: 'Correo electrónico es requerido',
                },
                {
                  required: true,
                  type: 'email',
                },
              ]}
            >
              <Input
                allowClear
                placeholder="Correo electrónico..."
                disabled={readOnly}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="cargo_persona_contacto"
              label="Cargo"
              rules={[
                {
                  required: true,
                  message: 'Cargo es requerido',
                },
              ]}
            >
              <Input allowClear placeholder="Cargo..." disabled={readOnly} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default LegalPersonFormGeneralSection;
